import React from "react";
import { ToWords } from "to-words";

const CurrencyWord = (props) => {
  let amount = parseFloat(props?.amount)?.toFixed(3)?.split(".")?.[0];
  let decimalAmount = parseFloat(props?.amount)?.toFixed(3)?.split(".")?.[1];

  const toWords = new ToWords({
    localeCode: "en-IN",
    converterOptions: {
      currency: false,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: false,
    },
  });

  let amtountWord =
    amount > 0 && decimalAmount > 0
      ? "Omani Riyal " + toWords.convert(amount)
      : amount > 0 && decimalAmount == 0
      ? "Omani Riyal " + toWords.convert(amount) + " Only"
      : "";
  let amountDecimalWord =
    decimalAmount > 0 && amount > 0
      ? " And " + toWords.convert(decimalAmount) + " Baisa Only."
      : decimalAmount > 0 && amount == 0
      ? toWords.convert(decimalAmount) + " Baisa Only."
      : "";

  let amountInWords = amtountWord + amountDecimalWord;
  return amountInWords;
};

export default CurrencyWord;
